import cookie from "react-cookies";
export const clearCookiesAndLocalStorage = () => {
  let name = "bossfotos";
  let auto_reset_version = "1";
  console.log(`${name} v${auto_reset_version} 😎`);
  const last_version = localStorage.getItem(`${name}-Version`);
  if (last_version !== auto_reset_version) {
    console.log("New Version Available ! 😝");
    var cookies = document.cookie.split(";");
    if (cookies.length > 1) {
      for (var i = 0; i < cookies.length; i++)
        cookie.remove(cookies[i].split("=")[0]);
    }
    window.location.reload(true);
    localStorage.setItem(`${name}-Version`, auto_reset_version);
    // localStorage.clear();
  }
};
